// import React, { useState, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom'; // Import useLocation
// import html2pdf from 'html2pdf.js';
// import cisceLogo from '../../img/cisce.png';

// const ResultPage = () => {
//   const API_BASE_URL = 'https://peakybalvinder.pythonanywhere.com/api';
//   const navigate = useNavigate();
//   const location = useLocation(); // Initialize useLocation hook

//   // Get indexNo from location.state instead of useParams
//   const indexNo = location.state?.indexNo;

//   const [studentData, setStudentData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     // Check if indexNo is available from the state
//     if (!indexNo) {
//       setError("No student ID provided for result display.");
//       setLoading(false);
//       return;
//     }

//     const fetchStudent = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const response = await fetch(`${API_BASE_URL}/public/students/${indexNo}`, {
//           method: 'GET',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//         });

//         if (!response.ok) {
//           const errorData = await response.json();
//           if (response.status === 404) {
//             throw new Error("Result not found for this Index Number.");
//           }
//           throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
//         }
//         const data = await response.json();
//         setStudentData(data);
//       } catch (err) {
//         console.error('Error fetching student for Result Page:', err);
//         setError(err.message || 'Failed to load student data.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchStudent();
//   }, [indexNo, navigate, location.state]); // Add location.state to dependencies

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     try {
//       const date = new Date(dateString);
//       const day = String(date.getDate()).padStart(2, '0');
//       const month = String(date.getMonth() + 1).padStart(2, '0');
//       const year = date.getFullYear();
//       return `${day}-${month}-${year}`;
//     } catch (e) {
//       return 'Invalid Date';
//     }
//   };

//   const formatIndexNo = (indexNoString) => {
//     if (!indexNoString || String(indexNoString).length !== 10) return indexNoString;
//     const part1 = String(indexNoString).substring(0, 7);
//     const part2 = String(indexNoString).substring(7, 10);
//     return `${part1} / ${part2}`;
//   };

//   const formatTimestamp = (date) => {
//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = String(date.getFullYear()).slice(-2);

//     let hours = date.getHours();
//     const minutes = String(date.getMinutes()).padStart(2, '0');
//     const ampm = hours >= 12 ? 'PM' : 'AM';
//     hours = hours % 12;
//     hours = hours ? hours : 12;
//     const formattedTime = `${hours}:${minutes} ${ampm}`;

//     return `${month}/${day}/${year}, ${formattedTime}`;
//   };

//   const formatBottomTimestamp = (date) => {
//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = date.getFullYear();

//     let hours = date.getHours();
//     const minutes = String(date.getMinutes()).padStart(2, '0');
//     const ampm = hours >= 12 ? 'PM' : 'AM';
//     hours = hours % 12;
//     hours = hours ? hours : 12;

//     return `${day}/${month}/${year} ${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;
//   };

//   const downloadPdf = () => {
//     const element = document.getElementById('result-content');

//     if (element) {
//       const originalOverflow = document.body.style.overflow;
//       document.body.style.overflow = 'hidden';

//       const opt = {
//         margin: 0,
//         filename: `Result_${studentData.candidateName.replace(/\s/g, '_')}_${studentData.indexNo}.pdf`,
//         image: { type: 'jpeg', quality: 0.98 },
//         html2canvas: {
//           scale: 4,
//           logging: true,
//           dpi: 600,
//           letterRendering: true,
//           useCORS: true,
//           windowWidth: element.scrollWidth,
//           windowHeight: element.scrollHeight,
//           width: element.offsetWidth,
//         },
//         jsPDF: {
//           unit: 'mm',
//           format: [209.9, 297.1],
//           orientation: 'portrait'
//         }
//       };

//       html2pdf().set(opt).from(element).save().then(() => {
//         document.body.style.overflow = originalOverflow;
//       });
//     } else {
//       console.error('Could not find element with ID "result-content" for PDF conversion.');
//     }
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center min-h-screen bg-gray-100">
//         <p className="text-xl text-blue-600">Loading student result...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex flex-col justify-center items-center min-h-screen bg-gray-100 p-4">
//         <p className="text-xl text-red-600 mb-4">Error: {error}</p>
//         <button
//           onClick={() => navigate('/dashboard')}
//           className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg transition duration-300"
//         >
//           Go to Dashboard
//         </button>
//       </div>
//     );
//   }

//   if (!studentData) {
//     return (
//       <div className="text-center py-10 text-gray-500 text-lg min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
//         <p className="mb-4">No student data found for the provided ID.</p>
//         <button
//           onClick={() => navigate('/dashboard')}
//           className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg transition duration-300"
//         >
//           Go to Dashboard
//         </button>
//       </div>
//     );
//   }

//   const allSubjectsForTable = [
//     ...(studentData.subjects || []),
//     { subjectName: 'SUPW & COMMUNITY SERVICE', marks: studentData.supwGrade, isSupw: true }
//   ].filter(s => s.marks !== undefined && s.marks !== null);

//   return (
//     <div className="flex flex-col items-center min-h-screen font-sans text-gray-800 py-8 bg-gray-50">

//       {/* Main content container - Precisely set width for 20.99cm at 96DPI */}
//       <div id="result-content" className="bg-white mx-auto px-10 py-8 relative shadow-lg border border-gray-200 text-[13.5px] leading-relaxed"
//            style={{ width: '793px' }}> {/* Precise width based on 20.99cm at 96 DPI */}

//         {/* Top-left Timestamp and Top-right Result Year */}
//         <div className="flex justify-between items-center text-[12px] mb-4">
//           <div className="text-left">{formatTimestamp(new Date())}</div>
//           <div className="font-semibold text-center flex-grow">CISCE Results {studentData.resultYear}</div>
//         </div>

//         {/* Header Section */}
//         <div className="flex items-start mb-0">
//           <div className="flex-shrink-0 mr-4">
//             <img src={cisceLogo} alt="CISCE Logo" className="h-18 w-28 object-contain" />
//           </div>
//           <div className="flex-grow text-center mt-2">
//             <p className="text-xl font-semibold uppercase leading-tight">COUNCIL FOR THE INDIAN SCHOOL CERTIFICATE</p>
//             <p className="text-xl font-semibold uppercase leading-tight">EXAMINATIONS</p>
//             {/* Moved this paragraph inside the same flex-grow, text-center div */}
//             <p className="text-[13.5px] font-medium uppercase tracking-wide leading-snug mt-1">
//               INDIAN CERTIFICATE OF
//               {studentData.classSelected === "Class XII" ? " SENIOR SECONDARY EDUCATION" : " SECONDARY EDUCATION"}
//               ({studentData.classSelected}) RESULTS {studentData.resultYear}
//             </p>
//           </div>
//         </div>

//         {/* Candidate Details Section */}
//         <div className="border-gray-300 py-3 mb-4 text-[13.5px] mt-4">
//           <div className="grid grid-cols-2 gap-x-12 gap-y-1">
//             <div>
//               <div className="grid grid-cols-[auto_1fr] gap-x-2 gap-y-1">
//                 <div className="font-bold">Candidate Name :</div>
//                 <div className="font-normal">{studentData.candidateName.toUpperCase() || 'N/A'}</div>

//                 <div className="font-bold">Unique Id :</div>
//                 <div className="font-normal">{studentData.candidateId.toUpperCase() || 'N/A'}</div>

//                 <div className="font-bold">Son of :</div>
//                 <div className="font-normal">
//                   {studentData.sonOf && studentData.sonOf.toUpperCase().split('\n').map((line, index) => (
//                     <React.Fragment key={index}>
//                       {line}
//                       {index < studentData.sonOf.toUpperCase().split('\n').length - 1 && <br />}
//                     </React.Fragment>
//                   )) || 'N/A'}
//                 </div>
//               </div>
//             </div>

//             <div>
//               <div className="grid grid-cols-[auto_1fr] gap-x-2 gap-y-1">
//                 {studentData.dob && (
//                   <>
//                     <div className="font-bold">Date of Birth :</div>
//                     <div className="font-normal">{formatDate(studentData.dob)}</div>
//                   </>
//                 )}

//                 <div className="font-bold">Index No :</div>
//                 <div className="font-normal">{formatIndexNo(studentData.indexNo) || 'N/A'}</div>

//                 <div className="font-bold">School :</div>
//                 <div className="font-normal">{studentData.school.toUpperCase() || 'N/A'}</div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Subjects and Marks Table */}
//         <div className="mb-1" style={{ border: '1px solid #c0e3ec' }}>
//           <table className="w-full text-left table-fixed">
//             <thead>
//               <tr className="" style={{ borderBottom: '1px solid #c0e3ec' }}>
//                 <th className="py-2 px-3 text-sm font-bold w-1/2">Subject</th>
//                 <th className="py-2 px-3 text-sm font-bold text-right w-1/2">Percentage Marks</th>
//               </tr>
//             </thead>
//             <tbody>
//               {allSubjectsForTable.length > 0 ? (
//                 allSubjectsForTable.map((subject, index) => (
//                   <tr
//                     key={index}
//                     style={{
//                       borderBottom: index === allSubjectsForTable.length - 1 ? 'none' : '1px solid #c0e3ec'
//                     }}
//                   >
//                     <td className="py-1.5 px-3 text-[13px] font-bold w-1/2">{subject.subjectName.toUpperCase()}</td>
//                     <td className="py-1.5 px-3 text-[13px] text-right w-1/2">{subject.marks !== undefined ? subject.marks : 'N/A'}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="2" className="p-4 text-center text-gray-500">No subject data available.</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Result Line */}
//         <div className="grid grid-cols-2 text-[13.5px] mb-2" style={{ borderBottom: '0px solid #c0e3ec' }}>
//             <div className="py-1 px-3 font-bold text-left">Result</div>
//             <div className="py-1 px-3 font-bold text-right">{studentData.result.toUpperCase() || 'N/A'}</div>
//         </div>

//         {/* Pass Certificate Awarded (will only show if result is 'PASS') */}
//         {studentData.result === 'PASS' && (
//             <div className="text-center font-extrabold text-xl mb-7">
//               PASS CERTIFICATE AWARDED
//             </div>
//           )}

//         {/* Disclaimer and Note */}
//         <div className="text-[10px] text-gray-700 leading-snug space-y-1.5 px-1 mt-7">
//             <p className="font-bold">Disclaimer</p>
//             <p className="text-left">
//                 All information on this print is provided free of cost for personal perusal only, and as such, is made available "AS IS". Every effort has been made to ensure accuracy of the data on this print. However, CISCE does not make any claim about the accuracy or validity of the content on this print, or its suitability for any specific purpose whatsoever, whether express or implied. CISCE will not be responsible for any errors or omissions on this Web print. In particular but without being limited thereto, CISCE disclaims any responsibility for typographical errors and other inaccuracies that may be contained within the print. Those users who access information on this Print have done so voluntarily of their own accord, any outcome (decision or claim) of such access is understood to be their sole sole responsibility. CISCE reserves the right to make changes to this information and print without notice.
//             </p>
//         </div>

//         {/* Footer - URL and Date/Time */}
//         <div className="flex justify-between items-end mt-8 text-[11px] text-gray-700">
//             <div>https://cisceu.org/</div>
//             <div>{formatBottomTimestamp(new Date())}</div>
//         </div>

//       </div>

//       {/* Download Button below the main content box */}
//       <div className="mt-8">
//         <button
//           onClick={downloadPdf}
//           className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition duration-300 text-lg shadow-md"
//         >
//           Print Result
//         </button>
//       </div>

//     </div>
//   );
// };

// export default ResultPage;



import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // Import useLocation
import html2pdf from 'html2pdf.js';
import cisceLogo from '../../img/cisce.png';

const ResultPage = () => {
  const API_BASE_URL = 'https://peakybalvinder.pythonanywhere.com/api';
  // const API_BASE_URL = 'http://127.0.0.1:5005/api';
  const navigate = useNavigate();
  const location = useLocation(); // Initialize useLocation hook to access navigation state

  // State to hold the indexNo, which will be determined from location.state or localStorage
  const [indexNo, setIndexNo] = useState(null);

  const [studentData, setStudentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let currentId = null;

    // 1. Try to get indexNo from location.state (used for internal React app navigation)
    if (location.state && location.state.indexNo) {
      currentId = location.state.indexNo;
      console.log("ResultPage: IndexNo found in location.state:", currentId);
    } else {
      // 2. Fallback: Try to get indexNo from localStorage (used for external HTML page navigation)
      currentId = localStorage.getItem('resultIndexNo');
      if (currentId) {
        console.log("ResultPage: IndexNo found in localStorage:", currentId);
        localStorage.removeItem('resultIndexNo'); // Clear it immediately after reading to prevent stale data
      } else {
        console.log("ResultPage: No indexNo found in location.state or localStorage.");
      }
    }

    // Update the component's state with the found indexNo
    setIndexNo(currentId);

    // If no indexNo was found from either source, set an error and stop loading
    if (!currentId) {
      setError("No result found! Please check your Course/UID/Index number and try again.");
      setLoading(false);
      return; // Exit useEffect early
    }

    // If an indexNo was found, proceed to fetch student data
    const fetchStudent = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`${API_BASE_URL}/public/students/${currentId}`, { // Use currentId for the API call
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          const errorData = await response.json();
          if (response.status === 404) {
            throw new Error("Result not found for this Index Number.");
          }
          throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setStudentData(data);
      } catch (err) {
        console.error('Error fetching student for Result Page:', err);
        setError(err.message || 'Failed to load student data.');
      } finally {
        setLoading(false);
      }
    };

    fetchStudent();
  // Dependencies: location.state (to re-run if navigation state changes) and navigate (stable reference)
  }, [location.state, navigate]);


  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (e) {
      return 'Invalid Date';
    }
  };

  const formatIndexNo = (indexNoString) => {
    // Prefer the indexNo from component state for display if available, otherwise use the passed string
    const displayIndexNo = indexNoString || indexNo;
    if (!displayIndexNo || String(displayIndexNo).length !== 10) return displayIndexNo;
    const part1 = String(displayIndexNo).substring(0, 7);
    const part2 = String(displayIndexNo).substring(7, 10);
    return `${part1} / ${part2}`;
  };

  const formatTimestamp = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedTime = `${hours}:${minutes} ${ampm}`;

    return `${month}/${day}/${year}, ${formattedTime}`;
  };

  const formatBottomTimestamp = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${day}/${month}/${year} ${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;
  };

  const downloadPdf = () => {
    const element = document.getElementById('result-content');

    if (element) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      const opt = {
        margin: 0,
        // Ensure studentData.indexNo is used here for PDF filename
        filename: `Result_${studentData.candidateName.replace(/\s/g, '_')}_${studentData.indexNo}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 4,
          logging: true,
          dpi: 600,
          letterRendering: true,
          useCORS: true,
          windowWidth: element.scrollWidth,
          windowHeight: element.scrollHeight,
          width: element.offsetWidth,
        },
        jsPDF: {
          unit: 'mm',
          format: [209.9, 297.1],
          orientation: 'portrait'
        }
      };

      html2pdf().set(opt).from(element).save().then(() => {
        document.body.style.overflow = originalOverflow;
      });
    } else {
      console.error('Could not find element with ID "result-content" for PDF conversion.');
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-100">
        <p className="text-xl text-blue-600">Loading student result...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col justify-center items-center min-h-screen bg-gray-100 p-4">
        <p className="text-xl text-red-600 mb-4">Error: {error}</p>
        <button
          onClick={() => navigate('/dashboard')}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg transition duration-300"
        >
          Go to Dashboard
        </button>
      </div>
    );
  }

  if (!studentData) {
    return (
      <div className="text-center py-10 text-gray-500 text-lg min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
        <p className="mb-4">No student data found for the provided ID.</p>
        <button
          onClick={() => navigate('/dashboard')}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg transition duration-300"
        >
          Go to Dashboard
        </button>
      </div>
    );
  }

  const allSubjectsForTable = [
    ...(studentData.subjects || []),
    { subjectName: 'SUPW & COMMUNITY SERVICE', marks: studentData.supwGrade, isSupw: true }
  ].filter(s => s.marks !== undefined && s.marks !== null);

  return (
    <div className="flex flex-col items-center min-h-screen font-sans text-gray-800 py-8 bg-gray-50">

      {/* Main content container - Precisely set width for 20.99cm at 96DPI */}
      <div id="result-content" className="bg-white mx-auto px-10 py-8 relative shadow-lg border border-gray-200 text-[13.5px] leading-relaxed"
           style={{ width: '793px' }}> {/* Precise width based on 20.99cm at 96 DPI */}

        {/* Top-left Timestamp and Top-right Result Year */}
        <div className="flex justify-between items-center text-[12px] mb-4">
          <div className="text-left">{formatTimestamp(new Date())}</div>
          <div className="font-semibold text-center flex-grow">CISCE Results {studentData.resultYear}</div>
        </div>

        {/* Header Section */}
        <div className="flex items-start mb-0">
          <div className="flex-shrink-0 mr-4">
            <img src={cisceLogo} alt="CISCE Logo" className="h-18 w-28 object-contain" />
          </div>
          <div className="flex-grow text-center mt-2">
            <p className="text-xl font-semibold uppercase leading-tight">COUNCIL FOR THE INDIAN SCHOOL CERTIFICATE</p>
            <p className="text-xl font-semibold uppercase leading-tight">EXAMINATIONS</p>
            {/* Moved this paragraph inside the same flex-grow, text-center div */}
            <p className="text-[13.5px] font-medium uppercase tracking-wide leading-snug mt-1">
              INDIAN CERTIFICATE OF
              {studentData.classSelected === "Class XII" ? " SENIOR SECONDARY EDUCATION" : " SECONDARY EDUCATION"}
              ({studentData.classSelected}) RESULTS {studentData.resultYear}
            </p>
          </div>
        </div>

        {/* Candidate Details Section */}
        <div className="border-gray-300 py-3 mb-4 text-[13.5px] mt-4">
          <div className="grid grid-cols-2 gap-x-12 gap-y-1">
            <div>
              <div className="grid grid-cols-[auto_1fr] gap-x-2 gap-y-1">
                <div className="font-bold">Candidate Name :</div>
                <div className="font-normal">{studentData.candidateName.toUpperCase() || 'N/A'}</div>

                <div className="font-bold">Unique Id :</div>
                <div className="font-normal">{studentData.candidateId.toUpperCase() || 'N/A'}</div>

                <div className="font-bold">Son of :</div>
                <div className="font-normal">
                  {studentData.sonOf && studentData.sonOf.toUpperCase().split('\n').map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      {index < studentData.sonOf.toUpperCase().split('\n').length - 1 && <br />}
                    </React.Fragment>
                  )) || 'N/A'}
                </div>
              </div>
            </div>

            <div>
              <div className="grid grid-cols-[auto_1fr] gap-x-2 gap-y-1">
                {studentData.dob && (
                  <>
                    <div className="font-bold">Date of Birth :</div>
                    <div className="font-normal">{formatDate(studentData.dob)}</div>
                  </>
                )}

                <div className="font-bold">Index No :</div>
                <div className="font-normal">{formatIndexNo(studentData.indexNo) || 'N/A'}</div>

                <div className="font-bold">School :</div>
                <div className="font-normal">{studentData.school.toUpperCase() || 'N/A'}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Subjects and Marks Table */}
        <div className="mb-1" style={{ border: '1px solid #c0e3ec' }}>
          <table className="w-full text-left table-fixed">
            <thead>
              <tr className="" style={{ borderBottom: '1px solid #c0e3ec' }}>
                <th className="py-2 px-3 text-sm font-bold w-1/2">Subject</th>
                <th className="py-2 px-3 text-sm font-bold text-right w-1/2">Percentage Marks</th>
              </tr>
            </thead>
            <tbody>
              {allSubjectsForTable.length > 0 ? (
                allSubjectsForTable.map((subject, index) => (
                  <tr
                    key={index}
                    style={{
                      borderBottom: index === allSubjectsForTable.length - 1 ? 'none' : '1px solid #c0e3ec'
                    }}
                  >
                    <td className="py-1.5 px-3 text-[13px] font-bold w-1/2">{subject.subjectName.toUpperCase()}</td>
                    <td className="py-1.5 px-3 text-[13px] text-right w-1/2">{subject.marks !== undefined ? subject.marks : 'N/A'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2" className="p-4 text-center text-gray-500">No subject data available.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Result Line */}
        <div className="grid grid-cols-2 text-[13.5px] mb-2" style={{ borderBottom: '0px solid #c0e3ec' }}>
            <div className="py-1 px-3 font-bold text-left">Result</div>
            <div className="py-1 px-3 font-bold text-right">{studentData.result.toUpperCase() || 'N/A'}</div>
        </div>

        {/* Pass Certificate Awarded (will only show if result is 'PASS') */}
        {studentData.result === 'PASS' && (
            <div className="text-center font-extrabold text-xl mb-7">
              PASS CERTIFICATE AWARDED
            </div>
          )}

        {/* Disclaimer and Note */}
        <div className="text-[10px] text-gray-700 leading-snug space-y-1.5 px-1 mt-7">
            <p className="font-bold">Disclaimer</p>
            <p className="text-left">
                All information on this print is provided free of cost for personal perusal only, and as such, is made available "AS IS". Every effort has been made to ensure accuracy of the data on this print. However, CISCE does not make any claim about the accuracy or validity of the content on this print, or its suitability for any specific purpose whatsoever, whether express or implied. CISCE will not be responsible for any errors or omissions on this Web print. In particular but without being limited thereto, CISCE disclaims any responsibility for typographical errors and other inaccuracies that may be contained within the print. Those users who access information on this Print have done so voluntarily of their own accord, any outcome (decision or claim) of such access is understood to be their sole sole responsibility. CISCE reserves the right to make changes to this information and print without notice.
            </p>
        </div>

        {/* Footer - URL and Date/Time */}
        <div className="flex justify-between items-end mt-8 text-[11px] text-gray-700">
            <div>https://cisceu.org/</div>
            <div>{formatBottomTimestamp(new Date())}</div>
        </div>

      </div>

      {/* Download Button below the main content box */}
      <div className="mt-8">
        <button
          onClick={downloadPdf}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition duration-300 text-lg shadow-md"
        >
          Print Result
        </button>
      </div>

    </div>
  );
};

export default ResultPage;
